import React, { useState, useEffect } from "react";

import OverviewSection from "./Hompage/OverviewSection";
import SkillsSection from "./Hompage/SkillsSection";
import AboutSection from "./Hompage/AboutSection";
import ExperienceSection from "./Hompage/ExperienceSection";
import CompaniesSection from "./Hompage/CompaniesSection";
import Footer from "./Footer";
import Wave from "react-wavify";
import ClosingAnimatedLayer from "../ClosingAnimatedLayer";

const BlockLayout = () => {
  const [showLayer, setShowLayer] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setShowLayer(false);
    }, 1800);
  }, []);

  return (
    <div className="gridAreaOne grid">
      <div className="gridAreaOne">
        <div className="bg-[#f2f2f2]">
          <OverviewSection></OverviewSection>
        </div>
        <Wave
          className="rotate-180 relative bottom-2"
          fill="#f2f2f2"
          paused={false}
          options={{
            height: 30,
            amplitude: 30,
            speed: 0.3,
            points: 10,
          }}
        />
        <SkillsSection></SkillsSection>
        <Wave
          className="relative top-2"
          fill="#f2f2f2"
          paused={false}
          options={{
            height: 30,
            amplitude: 30,
            speed: 0.3,
            points: 10,
          }}
        />
        <div className="bg-[#f2f2f2]">
          <AboutSection></AboutSection>
        </div>
        <div className="bg-[#f2f2f2]">
          <CompaniesSection></CompaniesSection>
        </div>
        <Wave
          className="rotate-180 relative bottom-2"
          fill="#f2f2f2"
          paused={false}
          options={{
            height: 30,
            amplitude: 30,
            speed: 0.3,
            points: 10,
          }}
        />
        <ExperienceSection></ExperienceSection>
        <Footer> </Footer>
      </div>
      {showLayer && <ClosingAnimatedLayer></ClosingAnimatedLayer>}
    </div>
  );
};

export default BlockLayout;
